module.exports = __webpack_public_path__ + "assets/shinyInvert-bg-4698970c03d2ba98a22dfdb7001d642d.png";


//////////////////
// WEBPACK FOOTER
// ./button/libs/mfButtons/images/shinyInvert-bg.png
// module id = 61
// module chunks = 4